import { getDueWorkingDay } from '../../../../../../../../../../../../../lib/functions/dates';

export const calculatePaymentDates = (
  creditDetails: any,
  firstPaymentDate: Date,
  workingDayActive: 'active' | 'inactive',
  operationDate: Date,
  totalMonths: number,
) => {
  const paymentDates: any[] = [];

  let currentDate = new Date(firstPaymentDate);
  const dateFirstPayment = currentDate.getUTCDate();
  if (workingDayActive === 'active') {
    currentDate = getDueWorkingDay(currentDate);
  }
  let diffDays = Math.floor(
    (currentDate.getTime() - operationDate.getTime()) / (1000 * 60 * 60 * 24),
  );
  paymentDates.push({ date: new Date(currentDate), diffDays: diffDays });

  for (let i = 1; i < totalMonths; i++) {
    currentDate.setMonth(currentDate.getMonth() + 1);
    currentDate.setDate(dateFirstPayment);
    if (workingDayActive === 'active') {
      currentDate = getDueWorkingDay(currentDate);
    }
    const lastEntry = paymentDates[i - 1];
    diffDays =
      (currentDate.getTime() - lastEntry.date.getTime()) /
      (1000 * 60 * 60 * 24);
    paymentDates.push({ date: new Date(currentDate), diffDays: diffDays });
  }

  return paymentDates;
};
